import { useEffect } from 'react';
import { connect } from 'react-redux';
import { safeParseInt } from '../../../../shared/utils';
import { actions } from '../../messageCenter/modules';

// active messages (most) will call the service successvively fewer times
const BASE_REFRESH_TIMEOUT_MS = 113 * 997; // ~2 mins
const BASE_REFRESH_EXPONENTIAL_TIMEOUT_MS = 59 * 997; // ~1 min

type TPropsFromState = any;

type TPropsThatDispatch = {};

export type TOwnProps = {
  size: 'xx-small' | 'x-small' | 'small' | 'medium' | 'large';
  className?: string;
};

type TMessageCenterIconProps = TPropsFromState & TPropsThatDispatch & TOwnProps;

const DEFAULT_ICON_STYLES: any = {
  'xx-small': {
    fontSize: 18
  },
  'x-small': {
    fontSize: 20
  },
  small: {
    fontSize: 26
  },
  medium: {
    fontSize: 36
  },
  large: {
    fontSize: 56
  }
};

const MAX_REQUESTS_BEFORE_THROTTLED = 5;

const MessageCenterIconBase = (props: TMessageCenterIconProps) => {
  const { size, amount: baseAmount, requestsSinceChangeCount } = props;

  const amount = Math.min(999, safeParseInt(baseAmount, 0));

  const throttledMaxRequests = Math.min(requestsSinceChangeCount, MAX_REQUESTS_BEFORE_THROTTLED);

  useEffect(() => {
    // on initial page load we want to immediately fire off a request
    props.setMessageCenterUnreadRequested();
  }, []);

  useEffect(() => {
    // then we fire off requests on an interval afterwards
    const refreshTimeoutMs =
      BASE_REFRESH_TIMEOUT_MS + BASE_REFRESH_EXPONENTIAL_TIMEOUT_MS * Math.pow(2, throttledMaxRequests);
    const interval = setInterval(() => {
      props.setMessageCenterUnreadRequested();
    }, refreshTimeoutMs);
    return () => clearInterval(interval);
  }, [throttledMaxRequests]);

  return (
    <span className="fa-layers fa-fw">
      <i className={`fas ${amount > 0 ? 'fa-comment-lines' : 'fa-comment'}`} style={DEFAULT_ICON_STYLES[size]} />
      {amount > 0 && <span className="fa-layers-counter">{amount}</span>}
    </span>
  );
};

// take state from store and convert into props
function mapStateToProps(state: any): TPropsFromState {
  return {
    ...state.messageCenter.unreadAmount
  };
}

export const MessageCenterIcon = connect<any, any, any>(mapStateToProps, actions)(MessageCenterIconBase);
